module.exports = __webpack_public_path__ + "static/media/Bootstrap.40eb74a6.svg";